export const UserNotificationMethod = {
  EMAIL: 'EMAIL',
  CBMS_WEBSITE: 'CBMS_WEBSITE',
  // TODO: Webhook
  // TODO: SMS
};
